<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
              type: 'emptyMenuBarInit'
            }),
            new fields.Input({
              label: 'Adres e-mail',
              required: true,
              modelPath: [this, 'form', 'email']
            })
          ]
        }
      ]
    }
  }
}
</script>
